/**
 * Created by wawei on 2019-02-25.
 */

import React, { Component } from "react";
import { translate } from "react-i18next";
import { Modal, Button, Tree, Icon } from "antd";
import { httpRequest as request } from "../../common/functions/CustomRequest.js";
import Constants, { URL } from "../../common/Constants.js";
import getUrl from "../functions/CommonUtils.js";
import NotificationManager from "../../common/components/CustomNotificationManager.js";
import writeLog from "../../common/functions/LogUtil.js";
import Loading from "../../common/components/Loading.js";

class NewSwitchOrg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      switching: false,
      loading: false,
      selectedTid: "",
      selectedName: "",
      options: [],
      guestTenants: []
    };
  }

  showModal = () => {
    this.setState(
      {
        visible: true,
        switching: false,
        loading: true,
        selectedTid: "",
        selectedName: "",
        options: [],
        guestTenants: []
      },
      () => this.init()
    );
  };

  init = () => {
    this.getTenantInfo()
      .then(this.getDescendants)
      .then(this.transformToTree)
      .catch(this.handleErrors);
  };

  getTenantInfo = () => {
    const url = getUrl(
      Constants.tenantManager,
      false,
      true,
      "/self?tid=" + sessionStorage.getItem("tenantId")
    );
    return request(url, "get", {}).then(res => {
      this.setState({ guestTenants: res.body.tenants });
    });
  };

  /**
   * Get all descendants of current tenant
   * @returns the tenants tree
   */
  getDescendants = () => {
    const orgs = sessionStorage.getItem("ORG");
    if (orgs === null) {
      const tid = sessionStorage.getItem("tenantId");
      const url = getUrl(
        Constants.tenantManager,
        false,
        true,
        "/sub-tenants/descendants?tid=" + tid
      );
      return request(url, "get", {}).then(res => {
        const descendantData = res.body;
        this.setState({ descendantData });
        sessionStorage.setItem("ORG", JSON.stringify(descendantData));
      });
    } else {
      return new Promise((resolve, reject) => {
        this.setState({ descendantData: JSON.parse(orgs) });
        resolve();
      });
    }
  };

  /**
   * After getting all descendants and all tenant which can switch to,
   * combine the data together to form a tree.
   * Disable all nodes that cannot switch to.
   */
  transformToTree = () => {
    const { descendantData } = this.state;
    const availableIds = this.state.guestTenants.map(e => e.tenantId);
    const tree = this.convertDescToTree(descendantData, availableIds);
    const guestTree = this.convertGuestToTree(this.state.guestTenants);
    const options = guestTree.concat(new Array(tree)); // after this, the options are in tree form
    console.log(options);
    this.setState({ options, loading: false });
  };

  /**
   * The convert operation.
   * 1. If a node is in the available array, leave it in the tree.
   * 2. If a node isn't in the available array, but some of its descendants is in the available array, disable the node.
   * 3. If a node including all its descendants are not in the available array, remove it from the tree.
   * @param node
   * @param availableIds
   * @returns {{}}
   */
  convertDescToTree = (node, availableIds) => {
    let tree = {};
    if (availableIds.includes(node["tenantId"])) {
      let tmp = this.state.guestTenants.filter(
        e => e["tenantId"] !== node["tenantId"]
      ); // Remove this node from available array, since it will be added to the tree instead
      this.setState({ guestTenants: tmp });

      tree = {
        key: node["tenantId"],
        title: node["companyName"] + " (" + node["tenantDomain"] + ")",
        disableCheckbox: sessionStorage.getItem("tenantId") === node["tenantId"]
      };
    } else {
      tree = {
        disabled: true,
        title: "---"
      };
    }

    if (node["subTenants"] && this.checkAnyChildAvailable(node, availableIds)) {
      tree["children"] = node["subTenants"]
        .filter(sub => this.checkAnyChildAvailable(sub, availableIds))
        .map(sub => this.convertDescToTree(sub, availableIds));
    }
    return tree;
  };

  /**
   * Check if any descendants is in the available array
   * @param node
   * @param ids
   * @returns {boolean}
   */
  checkAnyChildAvailable = (node, ids) => {
    let flag = false;
    if (ids.indexOf(node["tenantId"]) !== -1) {
      return true;
    } else if (node["subTenants"]) {
      let subs = node["subTenants"];
      for (let i = 0; i < subs.length; i++) {
        let child = node["subTenants"][i];
        flag = this.checkAnyChildAvailable(child, ids);
        if (flag) {
          return true;
        }
      }
    }
    return flag;
  };

  /**
   * Structure all guest tenants to tree
   * @param guestTenants
   */
  convertGuestToTree = guestTenants => {
    // Sort all guest tenants, put root tenants in front, put child tenants behind
    guestTenants.sort((e1, e2) => {
      if (e1["path"] === null && e2["path"] === null) {
        return 0;
      } else if (e1["path"] === null) {
        return -1;
      } else if (e2["path"] === null) {
        return 1;
      } else {
        return e1["path"].length - e2["path"].length;
      }
    });

    let map = {};
    guestTenants.forEach(t => {
      let thisNode = {
        key: t.tenantId,
        value: t.tenantId,
        title: t["companyName"] + " (" + t["tenantDomain"] + ")",
        disableCheckbox: sessionStorage.getItem("tenantId") === t.tenantId
      };

      if (t["path"] === null) {
        // put root tenants directly
        map[t.tenantId] = thisNode;
      } else {
        // find parents by paths
        let parentIds = t["path"].split(",").filter(p => p !== "");
        let tmpNode = undefined;
        parentIds.forEach(id => {
          if (tmpNode === undefined) {
            tmpNode = map[id];
          } else {
            tmpNode = tmpNode["children"].filter(p => p.key === id)[0];
          }
        });
        if (tmpNode["children"]) {
          tmpNode["children"].push(thisNode);
        } else {
          tmpNode["children"] = [thisNode];
        }
      }
    });

    return Object.values(map);
  };

  handleErrors = err => {
    const { t } = this.props;
    console.error(err);
    this.setState({ options: [], loading: false });
    NotificationManager.error(t("TENENT.FAIL_FETCH"));
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  handleOk = () => {
    const { t } = this.props;
    this.setState({ switching: true });
    this.getSSOToken()
      .then(this.verifySSOToken)
      .then(() => {
        writeLog(
          "switch",
          "change account",
          "Change account to " + this.state.selectedName
        );
        request("/api/switchOrg", "post", { tid: this.state.selectedTid }); // to insure new tab opening
        this.setState({ switching: false, visible: false });
        NotificationManager.success(t("TENENT.SUCCESS_SWITCH"));
        this.props.history.replace(URL.SWITCH);
      })
      .catch(err => {
        this.setState({ switching: false });
        NotificationManager.error(t("TENENT.FAILED_SWITCH"));
        console.error("Failed to change account.", err);
      });
  };

  getSSOToken = () =>
    request(
      getUrl(
        Constants.orionUserAuth,
        false,
        true,
        "/guest/sso?tid=" + sessionStorage.getItem("tenantId")
      ),
      "get",
      null
    ).then(res => {
      return res.body.token;
    });

  verifySSOToken = token =>
    request(
      getUrl(
        Constants.orionUserAuth,
        false,
        true,
        "/guest/sso?tid=" + this.state.selectedTid
      ),
      "post",
      { token }
    ).then(response => {
      return response;
    });

  getTreeNodes = options => {
    if (options) {
      return options.filter(o => o !== undefined).map(o => {
        return (
          <Tree.TreeNode
            title={o.title}
            key={o.key}
            disabled={o.disabled}
            selectable={false}
            disableCheckbox={o.disableCheckbox ? o.disableCheckbox : false}
          >
            {this.getTreeNodes(o.children)}
          </Tree.TreeNode>
        );
      });
    } else {
      return "";
    }
  };

  onCheck = (keys, e) => {
    const selected = this.state.selectedTid;
    let checked = "";
    let name = "";
    if (keys.checked.length === 0) {
      checked = "";
      name = "";
    } else if (keys.checked.length === 1) {
      checked = keys.checked[0];
      name = e["checkedNodes"][0]["props"]["title"];
    } else if (keys.checked.length > 1) {
      let tmp = keys.checked.filter(e => e !== selected);
      let tmp1 = e["checkedNodes"].filter(e => e.key !== selected);

      checked = tmp.length > 0 ? tmp[0] : "";
      name = tmp1.length > 0 ? tmp1[0].props.title : "";
    }
    this.setState({ selectedTid: checked, selectedName: name });
  };

  render() {
    const { t, companyName } = this.props;
    const { visible, switching, selectedTid, loading, options } = this.state;
    const nodes = this.getTreeNodes(options);

    return (
      <div>
        <a
          onClick={this.showModal}
          title={t("TENENT.SWITCH_ORG")}
          id="switchOrg.link"
        >
          {companyName}
          <Icon type="caret-down" style={{ marginLeft: 10, fontSize: 10 }} />
        </a>

        <Modal
          visible={visible}
          title={t("TENENT.SWITCH_ORG")}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          maskClosable={false}
          closable={false}
          bodyStyle={{ maxHeight: 400, overflowY: "auto", overflowX: "hidden" }}
          width="550px"
          footer={[
            <Button
              id="switchOrg.save"
              key="submit"
              type="primary"
              disabled={selectedTid === ""}
              size="large"
              onClick={this.handleOk}
              loading={switching}
            >
              {t("TENENT.SWITCH")}
            </Button>,
            <Button
              id="switchOrg.cancel"
              key="back"
              size="large"
              onClick={this.handleCancel}
              disabled={switching}
            >
              {t("COMMON.CANCEL")}
            </Button>
          ]}
        >
          <div style={{ margin: "0 20px" }}>
            {loading ? (
              <div style={{ width: "100%", textAlign: "center" }}>
                <Loading tip={t("COMMON.LOADING")} />
              </div>
            ) : (
              <div className="switch-org">
                <Tree
                  defaultExpandAll
                  checkable={true}
                  checkStrictly={true}
                  onCheck={this.onCheck}
                  checkedKeys={selectedTid ? [selectedTid] : []}
                  defaultSelectedKeys={[sessionStorage.getItem("tenantId")]}
                >
                  {nodes}
                </Tree>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default translate()(NewSwitchOrg);



// WEBPACK FOOTER //
// ./src/common/struct/NewSwitchOrg.js